export default __webpack_public_path__ + "static/Premium-Fibre-Pillow5 2-12194fec9c1085785d332c2728c291a8.png";